<template>
  <b-row>
    <b-col md="12">
      <b-card>
        <b-row class="pt-sm-1">
          <b-col sm="1">
            <span class="card-title wise-card-title">검색 조건</span>
          </b-col>
          <b-col sm="1"><strong>검색어</strong></b-col>
          <b-col sm="2">
            <b-form-select id="basicSelect" v-model="queryParams.searchType" :plain="true" :options="searchTypeOptions" :value="'all'"></b-form-select>
          </b-col>
          <b-col sm="6">
              <b-form-input v-model="queryParams.keyword" placeholder="" v-on:keyup="$event.keyCode === 13 ? findRequest() : ''"></b-form-input>
          </b-col>
          <b-col sm="2" style="text-align: center;">
              <b-button variant="primary" style="width: 100%;" v-on:click="findRequest()">검색</b-button>
          </b-col>
        </b-row>

        <b-row class="pt-sm-1">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>기간검색</strong></b-col>
          <b-col sm="2">
            <date-picker v-model="fullDateTmp"
                        type="date"
                        range
                        placeholder="조회기간 선택"
                        :lang="datepickerLang"
                        @change="handleDateRangeChange"
                        style="width: 100%;"
            />
          </b-col>
          <b-col sm="5">
            <button type="button" class="btn btn-outline-primary" style="width: 61.72px;" v-on:click="dateRange('ALL')">전체</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('1WEEK')">1주일</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('1MONTH')">1개월</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('6MONTH')">6개월</button>
            <button type="button" class="btn btn-outline-primary" style="width: 61.72px;" v-on:click="dateRange('1YEAR')">1년</button>
          </b-col>
        </b-row>

        <b-row class="pt-sm-2">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>응답상태</strong></b-col>
          <b-col sm="10">
            <b-form-checkbox-group id="basicInlineCustom">
              <div class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="statusInChk_all" v-model="qaStatusArr.all" v-on:click="qaStatusArr = {all: true}">
                <label class="custom-control-label" for="statusInChk_all">전체</label>
              </div>
              <div class="custom-control custom-checkbox custom-control-inline" v-for="(item, idx) in qaStatusOptions">
                <input type="checkbox" class="custom-control-input" :id="'statusInChk'+(idx+1)" v-model="qaStatusArr[item.item_code]" :disabled="qaStatusArr.all">
                <label class="custom-control-label" :for="'statusInChk'+(idx+1)">{{item.item_name}}</label>
              </div>
            </b-form-checkbox-group>
          </b-col>
        </b-row>
      </b-card>
    </b-col>

    <b-col md="12">
      <b-card>
        <b-row>
          <b-col sm="12">
            <b-row>
              <b-col sm="4">
                <span class="pr-"><strong>총 {{items.length}}건</strong></span>
                <!-- <span style="color:#ea0000; font-weight:bold; font-size:15px" v-if="drDeleteRows.length == 0">* 클릭 하시면 상세내역 페이지로 이동합니다.</span>
                <span style="color:#222222; font-weight:bold; font-size:15px" v-if="drDeleteRows.length > 0">선택된 데이터 : {{drDeleteRows.length}}</span> -->
              </b-col>
              <b-col sm="3"></b-col>
              <b-col sm="4" class="my-1">
                <!-- <b-button variant="outline-danger" style="float:right" v-on:click="drNoticeDelete()" :disabled="drDeleteRows.length == 0" :class="drDeleteRows.length != 0 ? 'mx-1' : 'mx-1'">삭제</b-button> -->
              </b-col>
              <b-col md="1" class="my-1">
                <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
              </b-col>
            </b-row>
          </b-col>

          <b-col sm="12" class="pt-sm-1">
            <b-row>
              <b-col sm="1"></b-col>
              <b-col sm="12">
                <b-table
                  striped
                  hover
                  :fields="fieldItems"
                  :items="items"
                  :busy="items == 0"
                  :current-page="currentPage"
                  :per-page="perPage"
                  @row-clicked="qnaRowSelected">
                  <div slot="table-busy" class="text-center my-2">
                    <strong>데이터가 없습니다.</strong>
                  </div>
                  <template slot="rnum" slot-scope="data">
                    <div>{{data.item.rnum}}</div>
                  </template>
                  <template slot="qastatus_name" slot-scope="data">
                    <div>
                      <span :class="'badge badge-'+(data.item.qastatus == '1' ? 'primary' : data.item.qastatus == '2' ? 'success' : data.item.qastatus == '3' ? 'secondary' : '')" style="font-size:15px; color:#ffffff">
                        {{data.item.qastatus_name}}
                      </span>
                    </div>
                  </template>
                  <template slot="title" slot-scope="data">
                    <div>
                      <a href="javascript:void(0)" v-on:click="reqInfoGo(data.item)">{{data.item.title}}</a>
                    </div>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" class="pt-sm-1">
            <b-row class="pb-sm-2">
              <b-col sm="1"></b-col>
              <b-col sm="10" class="my-1">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="listRows"
                  :per-page="perPage"
                  align="center"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
    </b-col>

    <!--
    <b-col sm="12">
      <b-card >
        <b-row class="mt-sm-5">
          <b-col sm="12">
            <table class="table table-bordered oddBackground">
              <tbody>
              <tr>
                <td style="width:20%">
                  고객 문의 내역
                  <br>작성자 : {{selectedQNA.user_name}}
                  <br>등록일 : {{selectedQNA.reg_date}}
                </td>
                <td style="width:80%">
                  <div>
                    <p class="card-text" style="white-space:pre-line;">
                      {{selectedQNA.contents}}
                    </p>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
            <table class="table table-bordered oddBackground">
              <tbody>
              <tr>
                <td style="width:20%">
                  관리자 답변 내역
                  <span v-if="selectedQNA.qastatus=='2'">
                      <br>답변자 : {{selectedQNA.reply_reg_user}}
                      <br/>{{selectedQNA.reply_date}}
                    </span>
                  <br/>
                  <b-button v-if="selectedQNA.qastatus=='1'" variant="primary" v-on:click="replySave()">저장</b-button>
                </td>
                <td style="width:80%">
                  <p class="card-text" style="white-space:pre-line;">
                    <textarea name="" id=""  style="width:100%;height:150px;"
                              v-model="selectedQNA.reply"
                    >
                    </textarea>
                  </p>
                </td>
              </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
    -->
  </b-row>
</template>

<script>
import swal from 'sweetalert2';
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

const moment = require("moment");

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      datepickerLang: {
          yearFormat: "YYYY년",
          monthFormat: "M월",
          days:["일","월","화","수","목","금","토"]
      },
      fullDateTmp: [],
      userInfo:{},
      queryParams: {
        name: '',
        content: '',
        endDate: '',
        startDate: '',
        searchType: 'all',
        qastatus:'0',
      },
      searchTypeOptions: [
        {text:'전체', value:'all'},
        {text:'제목', value:'title'},
        {text:'내용', value:'contents'},
        // {text:'작성자 아이디', value:'user_id'},
        {text:'작성자 명', value:'user_name'},
      ], // 상단 검색어 셀렉트 박스
      qaStatusOptions: [
        {item_name:'응대대기', item_code:'1'},
        {item_name:'응대완료', item_code:'2'},
      ],
      qaStatusArr: {all:true},
      listRows: 0,
      // totalRows: 30,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 30, 50, 100],
      fieldItems: [{
        // 'selectcheck': {
        //     'label': '선택',
        //     'class': 'text-center',
        //     'tdClass': 'text-vmiddle',
        //     'thStyle': {
        //       'vertical-align': 'middle'
        //     }
        //   }
        },{
          'rnum': {
            'label': '번호',
            'class': 'text-center',
            'tdClass': 'text-vmiddle',
            'thStyle': {
              'vertical-align': 'middle',
              'text-align': 'center',
              'width': '100px'
            }
          }
        }, {
          'qastatus_name': {
            'label': '응대상태',
            'class': 'text-center',
            'tdClass': 'text-vmiddle',
            'thStyle': {
              'vertical-align': 'middle',
              'text-align': 'center',
              'width': '120px'
            }
          }
          }, {
          'title': {
            'label': '제목',
            // 'class': 'text-center',
            'tdClass': 'text-vmiddle',
            'thStyle': {
              'vertical-align': 'middle',
              'text-align': 'center'
            }
          }
        },{
          'user_name': {
            'label': '작성자',
            'class': 'text-center',
            'tdClass': 'text-vmiddle',
            'thStyle': {
              'vertical-align': 'middle',
              'text-align': 'center',
              'width': '120px'
            }
          }
        }, {
          'reg_date': {
            'label': '등록일',
            'class': 'text-center',
            'tdClass': 'text-vmiddle',
            'thStyle': {
              'vertical-align': 'middle',
              'text-align': 'center',
              'width': '150px'
            }
          }
        }
        // }, {
        //   'user_position': {
        //     'label': '직책',
        //     'class': 'text-center',
        //     'tdClass': 'text-vmiddle',
        //     'thStyle': {
        //       'vertical-align': 'middle',
        //       'text-align': 'center'
        //     }
        //   }
        // }, {
        //   'user_company': {
        //     'label': '소속',
        //     'class': 'text-center',
        //     'tdClass': 'text-vmiddle',
        //     'thStyle': {
        //       'vertical-align': 'middle',
        //       'text-align': 'center'
        //     }
        //   }
        // }, {
        //   'user_email': {
        //     'label': '이메일',
        //     'class': 'text-center',
        //     'tdClass': 'text-vmiddle',
        //     'thStyle': {
        //       'vertical-align': 'middle',
        //       'text-align': 'center'
        //     }
        //   }
        // }, {
        //   'user_phone': {
        //     'label': '전화번호',
        //     'class': 'text-center',
        //     'tdClass': 'text-vmiddle',
        //     'thStyle': {
        //       'vertical-align': 'middle',
        //       'text-align': 'center'
        //     }
        //   }
        // , {
        //   'reply_date': {
        //     'label': '응대일자',
        //     'thStyle': { 'width': '5%'},
        //   }
        // }
        // , {
        //   'qastatus_change': {
        //     'label': '응대변경',
        //   }
        // }
      ],
      items: [],
      selectedQNA:{
        id:'',
        conn_id:'',
        title:'',
        reg_user:'',
        reg_date:'',
        check_yn:'',
        type_code:'',
        contents:'',
        user_name:'',
        join_date:'',
        mobile:'',
        type_name:'',
        reply:'',
        qastatus:'',
        qastatus_name:'',
        reply_date:'',
        reply_id:0,
        reply_reg_user:'',
      },
    }
  },
  watch: {},
  mounted: function() {
    this.userInfo = this.$session.get('userInfo');

    var self = this;

    // 최초 날짜 갱신(이번달)
    self.dateRange('this_month');
    // 최초 리스트 갱신
    this.findRequest();
  },
  methods: {
    keyhandler(event){
      event.preventDefault();
    },
    // 보고서 의뢰 리스트 조회
    findRequest() {
      var self = this;

      self.queryParams.qaStatusSearchArr = [];
      for(var type in self.qaStatusArr){
        if(self.qaStatusArr.hasOwnProperty(type)){
          if(self.qaStatusArr[type] == true){
            if(type != "all"){
              self.queryParams.qaStatusSearchArr.push(type);
            }
          }
        }
      }

      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(this.queryParams));

      var data = new FormData();
      data.append('objs', param);

      self.$http.post('/api/select/reportRequestList?access_token=' + token, data, null)
        .then((result) => {
          console.log(result.data);
          self.items = result.data;
          self.listRows = result.data.length;

          self.items.forEach(function (el, idx, arr){
            el.rnum = self.listRows - (idx);
            // el.selectchecked = false;
          });
      });
    },
    qnaRowSelected(item, index, event){
      console.log(item)
      this.selectedQNA = item;
    },
    replySave(){

      var token = sessionStorage.getItem("myToken");
      this.selectedQNA.reply_date = moment().format('YY-MM-DD HH:mm:ss');
      this.selectedQNA.reply_reg_user = this.userInfo.manager_id;

      var reply = this.$_.clone(this.selectedQNA);
      reply.contents = '';

      var param = encodeURI(JSON.stringify(reply));

      var data = new FormData();
      data.append('objs', param);

      this.$http.post('/api/insert/ReportRequestReply?access_token=' + token, data, null)
        .then((result) => {
          console.log('ReportRequestReply :: ',result.data)
          if(result.data > 0){
            swal.fire({
              type: 'success',
              title: '답변을 등록 했습니다.',
              showConfirmButton: false,
              timer: 1500
            })
            this.selectedQNA.qastatus = '2';
            this.selectedQNA.qastatus_name = '응대완료';
            this.selectedQNA.reply_id = result.data;
          }
        });
    },
    // 날짜 정의
    dateRange(flag) {
      let endDate = new Date();
      let startDate = new Date();

      if(flag == 'this_month'){
        startDate = new Date(endDate.getFullYear(), endDate.getMonth(), 1);
      }else if(flag == '1WEEK'){
        startDate.setDate(endDate.getDate() - 7);
      }else if(flag == '1MONTH'){
        startDate.setMonth(endDate.getMonth() - 1);
      }else if(flag == '6MONTH'){
        startDate.setMonth(endDate.getMonth() - 6);
      }else if(flag == '1YEAR'){
        startDate.setFullYear(endDate.getFullYear() - 1);
      }
      this.fullDateTmp = [startDate, endDate];
      if(flag == 'ALL'){
          this.fullDateTmp = [];
      }
      this.handleDateRangeChange();
    },
    handleDateRangeChange() {
      var self = this;
      if(self.fullDateTmp.length > 0){
        self.queryParams.startDate = moment(self.fullDateTmp[0]).format("YYYY-MM-DD");
        self.queryParams.endDate = moment(self.fullDateTmp[1]).format("YYYY-MM-DD");
      }else{
        self.queryParams.startDate = '';
        self.queryParams.endDate = '';
      }
    },
    reqInfoGo(row) {
      var self = this;
      self.$session.set('reqCode', row.id);
      location.href = '#/customer/reportrequest/info';
    },
  }
}
</script>
<style lang="css" scoped>
.oddBackground td:nth-child(odd) {
  background:#dcdcdc;
  font-weight: 600;
}
.theader{
  background:#dcdcdc;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/views/customer/ReportRequestPublic.vue